import React, { useState } from 'react';

import { nanoid } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { bemCssModules } from '@utils';
import { useNavigate } from '@utils/hooks';

import { userActions, useStore } from '@modules';
import { VerifyNextEnum } from '@modules/types';

import Tooltip from '@components/Tooltip';
import Verification from '@containers/Verification';

import style from './Verification.scss';

const cn = bemCssModules(style, 'Verification');
export type ChangePhoneVerifyPhoneType = {
  onSuccess(): void;
};
const { verifyEmail, verifyPhone } = VerifyNextEnum;

export const ChangePhoneVerifyOTP: CustomFC<ChangePhoneVerifyPhoneType> = props => {
  const { t } = useTranslation();
  const { onSuccess } = props;
  const [resendButtonId] = useState(nanoid());
  const [isOpen, setIsOpen] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();

  const [{ withdraw }, dispatch] = useStore();
  const isLoading = !!withdraw.loaders.withdrawVerifyOTP;

  const handleSubmit = (code: string) => {
    const token = state.token;
    dispatch(userActions.changePhoneVerifyOTP({ token, code }))
      .unwrap()
      .then(({ data }) => {
        if (data.next === verifyEmail) {
          navigate<'verifications'>(CONST.nav.verification, {
            state: {
              ...state,
              flow: 'changePhoneVerifyEmail',
            },
          });
        } else if (data.next === verifyPhone) {
          navigate<'verifications'>(CONST.nav.verification, {
            state: {
              ...state,
              flow: 'changePhoneVerifyPhone',
            },
          });
        } else {
          onSuccess();
        }
      });
  };

  const handleClick = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <Verification
      customInputClass={cn('custom-input')}
      onVerify={handleSubmit}
      isLoading={isLoading}
      type="2fa"
      codeLength={6}
      description={t('otp.description')}
      hideResend
      id={resendButtonId}
    >
      <div className={cn('lost')}>
        <button className={cn('link', ['link'])} onClick={handleClick}>
          {t('otp.lost.button')}
        </button>
        <Tooltip isOpen={isOpen}>
          <div className={cn('header')}>{t('otp.lost.header')}</div>
          <div className={cn('description')}>{t('otp.lost.description')}</div>
        </Tooltip>
      </div>
    </Verification>
  );
};
export default ChangePhoneVerifyOTP;
